export const publicRoutes = [
  '/login',
  '/signup',
  '/sso-signup',
  '/sent-email',
  '/activate',
  '/resetpassword',
  '/success',
  '/activate-failed',
  '/forgot-password',
  '/verify-mfa',
  '/sso/:provider/callback',
  '/oidc',
  '/subscription-confirm',
  '/unsubscribe',
];
